// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentMethod-paymentMethodBoxTopRadius-cVE7V {
    border-radius: var(--radius-3) var(--radius-3) 0 0;
}

.PaymentMethod-paymentMethodBoxBottomRadius-YwxaN {
    border-radius: 0 0 var(--radius-3) var(--radius-3);
}

.PaymentMethod-paymentDropdownItemsFlex-T0fE1 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    word-break: break-word;
    white-space: pre-wrap;
}

.PaymentMethod-cardNumberShow-4NQXM {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 12px;
    padding: 6px 18px;
    border-radius: var(--radius-1);
    background-color: var(--background-secondary);
    margin-bottom: 6px;
    margin-top: 12px;
}

.PaymentMethod-creditCardInnerWrapper-ppEz7 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    grid-gap: 12px;
}

.PaymentMethod-paymentMethodList-nqRUA {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 6px;
}

.PaymentMethod-paymentMethodList-nqRUA>img {
    width: 24px;
    height: 24px;
}

.PaymentMethod-dropdownTickIcon-BwOM5 {
    width: 22px;
    height: 22px;
}`, "",{"version":3,"sources":["webpack://./src/components/BookingDetail/PriceDetails/PaymentMethod/PaymentMethod.css"],"names":[],"mappings":"AAAA;IACI,kDAAkD;AACtD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,8BAA8B;IAC9B,6CAA6C;IAC7C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".paymentMethodBoxTopRadius {\n    border-radius: var(--radius-3) var(--radius-3) 0 0;\n}\n\n.paymentMethodBoxBottomRadius {\n    border-radius: 0 0 var(--radius-3) var(--radius-3);\n}\n\n.paymentDropdownItemsFlex {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    word-break: break-word;\n    white-space: pre-wrap;\n}\n\n.cardNumberShow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 6px 18px;\n    border-radius: var(--radius-1);\n    background-color: var(--background-secondary);\n    margin-bottom: 6px;\n    margin-top: 12px;\n}\n\n.creditCardInnerWrapper {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    grid-gap: 12px;\n}\n\n.paymentMethodList {\n    display: flex;\n    gap: 6px;\n}\n\n.paymentMethodList>img {\n    width: 24px;\n    height: 24px;\n}\n\n.dropdownTickIcon {\n    width: 22px;\n    height: 22px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paymentMethodBoxTopRadius": `PaymentMethod-paymentMethodBoxTopRadius-cVE7V`,
	"paymentMethodBoxBottomRadius": `PaymentMethod-paymentMethodBoxBottomRadius-YwxaN`,
	"paymentDropdownItemsFlex": `PaymentMethod-paymentDropdownItemsFlex-T0fE1`,
	"cardNumberShow": `PaymentMethod-cardNumberShow-4NQXM`,
	"creditCardInnerWrapper": `PaymentMethod-creditCardInnerWrapper-ppEz7`,
	"paymentMethodList": `PaymentMethod-paymentMethodList-nqRUA`,
	"dropdownTickIcon": `PaymentMethod-dropdownTickIcon-BwOM5`
};
module.exports = ___CSS_LOADER_EXPORT___;
